<template>
    <el-drawer class="drawer fs-credit-drawer" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" size="90%" direction="btt">
        <section class="content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="box">
                        <div class="box-body">
                            <div class="container">
                                <br>
                                <el-row>
                                    <el-col class="fs-user-profile_page">
                                        <!-- <li @click="toggle_term">
                                            <img class="fs-icon logout" src="@/assets/icons/shield.png">
                                            <label class="text-heading3">Term & Conditions</label>
                                            <i class="fas fa-chevron-right"></i>
                                        </li>
                                        <Term v-if="is_term" :is_policy="is_term"/> -->
                                        <li @click="toggle_policy">
                                            <img class="fs-icon logout" src="@/assets/icons/shield.png">
                                            <label class="text-heading3">Privacy Policy</label>
                                            <i class="fas fa-chevron-right"></i>
                                        </li>
                                        <PrivacyPolicy v-if="is_privacy_policy" :is_policy="is_privacy_policy"/>
                                        <li @click="toggle_cookie">
                                            <img class="fs-icon logout" src="@/assets/icons/shield.png">
                                            <label class="text-heading3">Cookie Policy</label>
                                            <i class="fas fa-chevron-right"></i>
                                        </li>
                                        <Cookie v-if="is_cookie" :is_policy="is_cookie"/>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </el-drawer>
</template>

<script>
import PrivacyPolicy from '@/components/profile/PrivacyPolicy'
import Term from '@/components/profile/Term'
import Cookie from '@/components/profile/Cookie'

export default {
    name: 'DrawerPolicy',
    props: {
        // is_privacy_policy: {
        //     default: false
        // }
    },
    components: {
        PrivacyPolicy,
        Term,
        Cookie
    },
    data() {
        return {
            is_open: true,
            cardDetail: null,
            is_privacy_policy: false,
            is_term: false,
            is_cookie: false,
            activeNames: ['1']
        }
    },
    mounted() {
        this.$store.dispatch('getUserCardList')
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        toggle_policy() {
            this.is_privacy_policy = !this.is_privacy_policy
        },
        toggle_term() {
            this.is_term = !this.is_term
        },
        toggle_cookie() {
            this.is_cookie = !this.is_cookie
        },
        back_page(value) {
            if (value == 'delete') {
                this.$store.dispatch('getUserCardList')
                setTimeout(() => {
                    this.page = 1
                }, 1000)
            } else {
                this.page = 1
            }
        }
    },
    computed: {

    },
    watch: {

    }
}


</script>
<style>
    .box-body {
        margin-top: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/profile/DrawerPolicy.vue